/* smoothScroll
========================================================= */
export function smoothScroll($) {
  $('a[href^="#"]').on('click.smoothScroll', function (event) {
    const href = $(this).attr('href');
    const selector = !href || href === '#' ? 'html' : href;
    const $target = $(selector);

    if (!$target.length) {
      return;
    }

    event.preventDefault();

    $('html, body').stop(true).animate(
      {
        scrollTop: $target.offset().top,
      },
      400,
      'swing'
    );
  });
}
